import { SALES_QUALIFIER_LINE_TELEPHONE } from '@Shared/constants';

import PhoneCallIcon from '../Icons/PhoneCallIcon';

export const className = {
    inner_phone_paragraph: 'text-base font-bold',
    schedule_paragragh: 'text-base ml-8',
    sm_inner_wrapper: 'flex items-center space-x-2',
};

export const LoanPreferencesHelp = () => (
    <a href={`tel:${SALES_QUALIFIER_LINE_TELEPHONE}`}>
        <div className='bg-white p-4 rounded-lg mt-4 mb-8 shadow hover:bg-gray-100 active:bg-gray-200 active:scale-95 transition transform duration-150'>
            <div className={className.sm_inner_wrapper}>
                <PhoneCallIcon />
                <p className={className.inner_phone_paragraph}>
                    Or call us now
                </p>
            </div>
            <p className={className.schedule_paragragh}>
                {SALES_QUALIFIER_LINE_TELEPHONE} (Mon - Fri, 9am - 5pm)
            </p>
        </div>
    </a>
);
